import { combineReducers } from "redux";
import { text as sendText } from "src/repositories/request.repository";

import {
    LOAD_REQUESTS_ERROR,
    LOAD_REQUESTS_SUCCESS,
    LOAD_REQUESTS_REQUEST,
    LOAD_REQUEST_ERROR,
    LOAD_REQUEST_REQUEST,
    LOAD_REQUEST_SUCCESS,
    SEND_TEXT_REQUEST,
    SEND_TEXT_SUCCESS,
    SEND_TEXT_ERROR
} from "modules/requests/actions/request.actions";

import { AUTH_LOGOUT } from "src/modules/auth/actions/authentication.action";

// send button in requesr-info
const sendInteraction = (state = null, action) => {
    switch (action.type) {
        case SEND_TEXT_SUCCESS:
            return action.payload;
        case SEND_TEXT_ERROR:
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
};

const data = (state = [], action) => {
    switch (action.type) {
        case LOAD_REQUESTS_SUCCESS:
            return action.payload;
        case AUTH_LOGOUT:
            return {};
        default:
            return state;
    }
};

const requestInformation = (state = null, action) => {
    switch (action.type) {
        case LOAD_REQUEST_SUCCESS:
            return action.payload;
        case LOAD_REQUEST_ERROR:
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
};

const isLoading = (state = false, action) => {
    switch (action.type) {
        case LOAD_REQUESTS_REQUEST:
            return true;
        case LOAD_REQUESTS_SUCCESS:
        case LOAD_REQUESTS_ERROR:
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};

const loadingRequest = (state = false, action) => {
    switch (action.type) {
        case LOAD_REQUEST_REQUEST:
            return true;
        case LOAD_REQUEST_SUCCESS:
        case LOAD_REQUEST_ERROR:
        case AUTH_LOGOUT:
            return false;
        default:
            return state;
    }
};

export default combineReducers({
    data,
    sendInteraction,
    isLoading,
    requestInformation,
    loadingRequest
});
